/**
 * [MCV-1945] Tutorial videos offered from the clapperboard buttons around the app.
 *
 * The videos are not produced or hosted yet, so every `url` is null and the button says so. To
 * publish one, set its `url`: a direct media file (.mp4, .webm, .mov, .m4v, .ogg) plays in a
 * native <video>, anything else (a YouTube or Vimeo embed URL) loads in an <iframe>.
 */
export type TutorialVideoId =
  | 'b2bListing'
  | 'jobListing'
  | 'searchProviders'
  | 'addAssociatedProviders'
  | 'mcvTour'
  | 'providerHlxTour';

export interface TutorialVideo {
  title: string;
  url: string | null;
}

export const TUTORIAL_VIDEOS: Record<TutorialVideoId, TutorialVideo> = {
  b2bListing: { title: 'How to Create a B2B Listing', url: null },
  jobListing: { title: 'How to Create a Job Listing', url: null },
  searchProviders: { title: 'How to Search Providers', url: null },
  addAssociatedProviders: { title: 'How to Add Associated Providers', url: null },
  mcvTour: { title: 'How to Create an AI-Parsed MCV Account (MCV Tour)', url: null },
  providerHlxTour: {
    title: 'How to Create a Service Listing (Provider HLX Tour)',
    url: null,
  },
};

const DIRECT_MEDIA_EXTENSION = /\.(mp4|webm|mov|m4v|ogg|ogv)$/i;

/** True for a URL that points straight at a media file, ignoring any query string or hash. */
export const isDirectMediaUrl = (url: string): boolean => {
  try {
    return DIRECT_MEDIA_EXTENSION.test(new URL(url, 'https://placeholder.invalid').pathname);
  } catch {
    return false;
  }
};
